import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLanguage = localStorage.getItem("i18nextLng");

const defaultLanguage =
  savedLanguage === "en" || savedLanguage === "de" ? savedLanguage : "en";

localStorage.setItem("i18nextLng", defaultLanguage);

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        header: {
          home: "Home",
          about: "About",
          services: "Services",
          contact: "Contact",
          cars: "Cars",
          workTime: "Mon-Sat: 9AM - 8PM | Sun: 10AM - 6PM",
        },

        home: {
          heroSubtitle: "REDEFINING THE DRIVING EXPERIENCE",
          heroTitleStart: "Welcome to our used car ",
          heroTitleHighlight: " dealership",
          browseInventory: "Browse Inventory",
          featuredTitle: "Featured Collection",
          featuredText:
            "Browse our handpicked selection of used vehicles, each carefully inspected and verified.",
          loadingCars: "Loading cars...",
          noCars: "No cars added yet.",
          available: "Available",
          unnamedCar: "Unnamed Car",
          unknownBrand: "Unknown Brand",
          priceRequest: "Price on request",
          viewDetails: "View Details",
          whyTitle: "Why Choose AutoPark",
          whyText:
            "We provide an unmatched experience in reliable car acquisition.",
          qualityTitle: "Quality Cars",
          qualityText:
            "Every vehicle undergoes rigorous inspection and verification.",
          trustedTitle: "Trusted Dealers",
          trustedText:
            "Work with certified and reputable dealers you can trust.",
          fastTitle: "Fast Process",
          fastText: "Streamlined experience from selection to delivery.",
          supportTitle: "Expert Support",
          supportText: "Dedicated team available to assist you every step.",
          ctaTitle: "Find the Right Car for You",
          ctaText:
            "Get in touch with our team and let us help you discover the perfect vehicle for your needs.",
          contactButton: "Contact Us",
        },

        about: {
          heroEyebrow: "Reliable. Transparent. Personal.",
          heroTitle: "Quality Used Cars at Fair Prices",
          heroTextOne:
            "Welcome to our used car dealership. We offer well-maintained used vehicles at fair prices and place great value on transparency, reliability, and personal customer service.",
          heroTextTwo:
            "Whether you are looking for your first car, a family vehicle, or a sporty model — we offer a selection of cars in different price ranges.",
          exploreCars: "Explore Cars",
          contactUs: "Contact Us",
          aboutEyebrow: "About Us",
          aboutTitle: "Honest Advice and a Smooth Buying Experience",
          aboutText:
            "We stand for honest advice and a smooth buying experience. Our goal is to offer our customers well-maintained vehicles at attractive prices — transparently and without unnecessary hassle.",
          purchaseEyebrow: "Vehicle Purchase",
          purchaseTitle: "Would You Like to Sell Your Vehicle?",
          purchaseText:
            "We buy used cars quickly and easily. Feel free to contact us for a non-binding offer.",
          fairValuation: "Fair valuation",
          fastProcess: "Fast process",
          quickResponse: "Quick response",
          getOffer: "Get an Offer",
          whyEyebrow: "Why Customers Choose Us",
          whyTitle: "Trust When Buying a Car",
          fairPricesTitle: "Fair Prices",
          fairPricesText:
            "Clear and honest pricing without unnecessary pressure.",
          serviceTitle: "Personal Customer Service",
          serviceText: "We help you find the right vehicle for your needs.",
          maintainedTitle: "Well-Maintained Vehicles",
          maintainedText:
            "Our cars are carefully selected and prepared for sale.",
          communicationTitle: "Transparent Communication",
          communicationText:
            "You get clear information before making a decision.",
          simpleProcessTitle: "Simple Process",
          simpleProcessText:
            "From first contact to final handover, everything is smooth.",
          qualityVehiclesTitle: "Quality Vehicles",
          qualityVehiclesText:
            "Quality vehicles. Fair deals. Your next car is waiting.",
          contactEyebrow: "Contact",
          contactTitle: "Do You Have Questions About a Vehicle?",
          contactText:
            "Would you like to schedule an appointment? Feel free to contact us by phone or message.",
        },

        services: {
          heroEyebrow: "Premium Automotive Services",
          heroTitle: "Service Built Around You",
          heroText:
            "From vehicle inspection to financing, delivery, and after-sale support — every service is designed for a smooth dealership experience.",
          bookConsultation: "Book Consultation",
          viewServices: "View Services",
          offerEyebrow: "What We Offer",
          offerTitle: "Everything You Need for a Confident Car Purchase",
          offerText:
            "Our dealership provides a complete automotive experience for clients who expect quality, trust, and expert support.",
          cards: [
            {
              number: "01",
              title: "Vehicle Sourcing",
              text: "We help you find the right vehicle based on your exact preferences.",
            },
            {
              number: "02",
              title: "Vehicle Inspection",
              text: "Every vehicle is carefully checked for condition, history, and quality.",
              dark: true,
            },
            {
              number: "03",
              title: "Financing Support",
              text: "Flexible financing options tailored to your budget and vehicle choice.",
            },
            {
              number: "04",
              title: "Trade-In Service",
              text: "Get a fair and professional valuation for your current vehicle.",
            },
            {
              number: "05",
              title: "Vehicle Delivery",
              text: "Your vehicle can be delivered safely and professionally.",
              dark: true,
            },
            {
              number: "06",
              title: "After-Sale Support",
              text: "We stay available after purchase to support documents, maintenance, and future needs.",
            },
          ],
          processEyebrow: "Process",
          processTitle: "How It Works",
          processText:
            "Our streamlined process ensures a smooth experience from start to finish.",
          steps: [
            {
              number: "01",
              title: "Consultation",
              text: "Discuss your needs and preferences",
            },
            {
              number: "02",
              title: "Selection",
              text: "We help you find the right vehicle",
            },
            {
              number: "03",
              title: "Inspection",
              text: "Thorough verification and checks",
            },
            {
              number: "04",
              title: "Handover",
              text: "Smooth handover to you",
            },
          ],
          featureImageAlt: "Car interior",
          privateEyebrow: "Customer Experience",
          privateTitle:
            "Designed for Customers Who Value Time, Detail, and Trust",
          privateText:
            "We remove the stress from buying a used vehicle. Our team helps with the search, verification, paperwork, and delivery while keeping you informed at every step.",
          startJourney: "Start Your Journey",
          ctaEyebrow: "Dealership Service",
          ctaTitle: "Ready to Find the Right Car?",
          ctaText:
            "Book a consultation and let our team guide you through a simple and transparent dealership experience.",
          scheduleAppointment: "Schedule Appointment",
        },

        cars: {
          pageTitle: "Our Inventory",
          pageSubtitle: "Browse our full collection of used vehicles",
          vehicleCategory: "Vehicle category",
          car: "Car",
          brand: "Brand",
          status: "Status",
          price: "Price",
          any: "Any",
          available: "Available",
          reserved: "Reserved",
          sold: "Sold",
          from: "from",
          until: "until",
          loading: "Loading cars...",
          noCars: "No cars found.",
          viewDetails: "View Details",
        },

        contact: {
          heroEyebrow: "Contact Us",
          heroTitle: "Let’s Find the Right Car for You",
          heroText:
            "Reach out to our team for vehicle inquiries, appointments, financing support, or dealership services.",
          getInTouch: "Get In Touch",
          infoTitle: "Visit Our Showroom or Send Us a Message",
          infoText:
            "Our team is ready to help you find, inspect, finance, and purchase your next vehicle.",
          location: "Location",
          locationValue: "Lennestadt, Germany",
          email: "Email",
          phone: "Phone",
          workingHours: "Working Hours",
          workingHoursValue: "Monday - Saturday: 09:00 - 18:00",
          fullName: "Full Name",
          emailAddress: "Email Address",
          phoneNumber: "Phone Number",
          subject: "Subject",
          message: "Your Message",
          sending: "Sending...",
          sendMessage: "Send Message",
          success: "Message sent successfully.",
          error: "Something went wrong. Please try again.",
          findUs: "Find Us",
          ourLocation: "Our Location",
          mapTitle: "Dealership Location",
        },

        singleCar: {
          loading: "Loading car...",
          notFound: "Car not found.",
          home: "Home",
          cars: "Cars",
          carName: "Car name",
          brand: "Brand",
          mileage: "Mileage",
          fuel: "Fuel",
          fuelType: "Fuel type",
          transmission: "Transmission",
          power: "Power",
          performance: "Performance",
          backToCars: "Back to cars",
          noImage: "No image",
          thumbnail: "Thumbnail",
          firstRegistration: "First registration",
          vehicleOwner: "Vehicle owner",
          technicalData: "Technical data",
          noTechnicalData: "No technical data available.",
          equipment: "Equipment",
          noEquipment: "No equipment listed.",
          vehicleDescription: "Vehicle description",
          noDescription: "No description available.",
          tel: "Tel",
          writeEmail: "Write an email",
          emailSubject: "Inquiry about",
          emailHello: "Hello,",
          emailInterested: "I am interested in the vehicle",
          emailMoreInfo: "Please send me more information.",
          emailThanks: "Thank you.",
        },

        admin: {
          panel: "Admin Panel",
          brand: "AutoPark",
          manageCars: "Manage Cars",
          addCar: "Add Car",
          backToSite: "← Back to Site",
          logout: "Logout",
          addCarTitle: "Add New Car",
          addCarSubtitle: "Add a new vehicle to your inventory",
          basicInfo: "Basic Information",
          carName: "Car Name",
          brandLabel: "Brand",
          year: "Year",
          price: "Price (€)",
          status: "Status",
          description: "Description",
          carPhotos: "Car Photos",
          uploadImages: "Upload Images",
          remove: "Remove",
          technicalData: "Technical Data",
          addStatistic: "+ Add Statistic",
          statisticName: "Statistic Name",
          selectStatistic: "Select statistic",
          value: "Value",
          equipment: "Equipment",
          addCarButton: "Add Car",
          uploading: "Uploading & Saving...",
          addNewImages: "Add New Images",
          images: "Images",
          manageCarsTitle: "Manage Cars",
          manageCarsSubtitle: "View, edit, delete and update car status.",
          loadingCars: "Loading cars...",
          noCarsFound: "No cars found.",
          noImage: "No Image",
          edit: "Edit",
          delete: "Delete",
          editFullCar: "Edit Full Car",
          saveChanges: "Save All Changes",
          saving: "Saving...",
          available: "Available",
          sold: "Sold",
          reserved: "Reserved",
          placeholderCarName: "e.g. Audi A4 S Line",
          placeholderBrand: "e.g. Audi",
          placeholderPrice: "25000",
          placeholderDescription: "Write car description...",
          placeholderValue: "e.g. Used vehicle",
          uploadOneImageAlert: "Please upload at least one car image.",
          requiredFieldsAlert: "Please fill all required fields.",
          successAddAlert: "Car added successfully!",
          deleteConfirm: "Are you sure you want to delete this car?",
          carNeedsImage: "Car must have at least one image.",
          failedAdd: "Failed to add car.",
          failedLoad: "Failed to load cars.",
          failedStatus: "Failed to update status.",
          failedDelete: "Failed to delete car.",
          failedUpdate: "Failed to update car.",

          spec: {
            vehicleCondition: "Vehicle condition",
            category: "Category",
            series: "Series",
            equipmentLine: "Equipment line",
            origin: "Origin",
            mileage: "Mileage",
            engineDisplacement: "Engine displacement",
            performance: "Performance",
            driveType: "Drive type",
            fuelType: "Fuel type",
            energyConsumption: "Energy consumption (combined)",
            co2Emissions: "CO₂ emissions (combined)",
            fuelConsumption: "Fuel consumption",
            seats: "Number of seats",
            doors: "Number of doors",
            transmission: "Transmission",
            exteriorColor: "Exterior color",
            interiorColor: "Interior color",
            bodyType: "Body type",
            firstRegistration: "First registration",
            warranty: "Warranty",
            vehicleOwner: "Vehicle owner",
            hu: "HU",
            airConditioning: "Air conditioning",
            parkingAssistance: "Parking assistance",
            airbags: "Airbags",
            cylinder: "Cylinder",
          },

          equipmentItems: {
            tintedWindows: "Tinted windows",
            abs: "ABS",
            alarmSystem: "Alarm system",
            detachableTowbar: "Detachable towbar",
            armrest: "Armrest",
            onBoardComputer: "On-board computer",
            cdPlayer: "CD player",
            electricWindows: "Electric window regulator",
            electricMirrors: "Electric side mirrors",
            immobiliser: "Electric immobiliser",
            esp: "ESP",
            frontWheelDrive: "Front-wheel drive",
            luggagePartition: "Luggage compartment partition",
            isofix: "Isofix",
            alloyWheels: "Alloy wheels",
            navigation: "Navigation system",
            fogLights: "Fog lights",
            breakdownKit: "Breakdown kit",
            particleFilter: "Particle filter",
            sunroof: "Sunroof",
            powerSteering: "Power steering",
            heatedSeats: "Heated seats",
            soundSystem: "Sound system",
            cruiseControl: "Cruise control",
            tractionControl: "Traction control",
            xenon: "Xenon headlights",
            centralLocking: "Central locking",
          },
        },
      },
    },

    de: {
      translation: {
        header: {
          home: "Startseite",
          about: "Über Uns",
          services: "Dienstleistungen",
          contact: "Kontakt",
          cars: "Autos",
          workTime: "Mo-Sa: 9Uhr - 20Uhr | So: 10Uhr - 18Uhr",
        },

        home: {
          heroSubtitle: "DAS FAHRERLEBNIS NEU DEFINIERT",
          heroTitleStart: "Willkommen bei",
          heroTitleHighlight: " Autopark Lennestadt",
          browseInventory: "Fahrzeuge ansehen",
          featuredTitle: "Ausgewählte Fahrzeuge",
          featuredText:
            "Entdecken Sie unsere Auswahl an Gebrauchtfahrzeugen, jedes sorgfältig geprüft und verifiziert.",
          loadingCars: "Autos werden geladen...",
          noCars: "Noch keine Autos hinzugefügt.",
          available: "Verfügbar",
          unnamedCar: "Unbenanntes Auto",
          unknownBrand: "Unbekannte Marke",
          priceRequest: "Preis auf Anfrage",
          viewDetails: "Details ansehen",
          whyTitle: "Warum AutoPark wählen",
          whyText:
            "Wir bieten ein zuverlässiges und transparentes Erlebnis beim Autokauf.",
          qualityTitle: "Qualitätsfahrzeuge",
          qualityText: "Jedes Fahrzeug wird gründlich geprüft und verifiziert.",
          trustedTitle: "Vertrauenswürdiger Händler",
          trustedText:
            "Kaufen Sie mit Vertrauen bei einem seriösen und zuverlässigen Händler.",
          fastTitle: "Schneller Prozess",
          fastText:
            "Ein reibungsloser Ablauf von der Auswahl bis zur Übergabe.",
          supportTitle: "Experten-Support",
          supportText:
            "Ein engagiertes Team unterstützt Sie bei jedem Schritt.",
          ctaTitle: "Finden Sie das richtige Auto für sich",
          ctaText:
            "Nehmen Sie Kontakt mit unserem Team auf und lassen Sie sich bei der Suche nach dem passenden Fahrzeug unterstützen.",
          contactButton: "Kontaktieren Sie uns",
        },

        about: {
          heroEyebrow: "Zuverlässig. Transparent. Persönlich.",
          heroTitle: "Qualitäts-Gebrauchtwagen zu fairen Preisen",
          heroTextOne:
            "Willkommen in unserem Gebrauchtwagenhandel. Wir bieten gepflegte Gebrauchtfahrzeuge zu fairen Preisen und legen großen Wert auf Transparenz, Zuverlässigkeit und persönlichen Kundenservice.",
          heroTextTwo:
            "Ob Sie Ihr erstes Auto, ein Familienfahrzeug oder ein sportliches Modell suchen — wir bieten eine Auswahl an Fahrzeugen in verschiedenen Preisklassen.",
          exploreCars: "Autos ansehen",
          contactUs: "Kontaktieren Sie uns",
          aboutEyebrow: "Über Uns",
          aboutTitle: "Ehrliche Beratung und ein reibungsloser Kaufprozess",
          aboutText:
            "Wir stehen für ehrliche Beratung und einen unkomplizierten Autokauf. Unser Ziel ist es, unseren Kunden gepflegte Fahrzeuge zu attraktiven Preisen anzubieten — transparent und ohne unnötigen Aufwand.",
          purchaseEyebrow: "Fahrzeugankauf",
          purchaseTitle: "Möchten Sie Ihr Fahrzeug verkaufen?",
          purchaseText:
            "Wir kaufen Gebrauchtwagen schnell und unkompliziert. Kontaktieren Sie uns gerne für ein unverbindliches Angebot.",
          fairValuation: "Faire Bewertung",
          fastProcess: "Schnelle Abwicklung",
          quickResponse: "Schnelle Rückmeldung",
          getOffer: "Angebot erhalten",
          whyEyebrow: "Warum Kunden uns wählen",
          whyTitle: "Vertrauen beim Autokauf",
          fairPricesTitle: "Faire Preise",
          fairPricesText:
            "Klare und ehrliche Preise ohne unnötigen Druck.",
          serviceTitle: "Persönlicher Kundenservice",
          serviceText:
            "Wir helfen Ihnen, das passende Fahrzeug für Ihre Bedürfnisse zu finden.",
          maintainedTitle: "Gepflegte Fahrzeuge",
          maintainedText:
            "Unsere Fahrzeuge werden sorgfältig ausgewählt und für den Verkauf vorbereitet.",
          communicationTitle: "Transparente Kommunikation",
          communicationText:
            "Sie erhalten klare Informationen, bevor Sie eine Entscheidung treffen.",
          simpleProcessTitle: "Einfacher Prozess",
          simpleProcessText:
            "Vom ersten Kontakt bis zur Übergabe läuft alles reibungslos.",
          qualityVehiclesTitle: "Qualitätsfahrzeuge",
          qualityVehiclesText:
            "Qualitätsfahrzeuge. Faire Angebote. Ihr nächstes Auto wartet.",
          contactEyebrow: "Kontakt",
          contactTitle: "Haben Sie Fragen zu einem Fahrzeug?",
          contactText:
            "Möchten Sie einen Termin vereinbaren? Kontaktieren Sie uns gerne telefonisch oder per Nachricht.",
        },

        services: {
          heroEyebrow: "Automobilservices",
          heroTitle: "Service, auf Sie zugeschnitten",
          heroText:
            "Von Fahrzeuginspektion über Finanzierung, Lieferung und Betreuung nach dem Kauf — jeder Service ist für ein reibungsloses Autohaus-Erlebnis entwickelt.",
          bookConsultation: "Beratung buchen",
          viewServices: "Services ansehen",
          offerEyebrow: "Was wir anbieten",
          offerTitle: "Alles, was Sie für einen sicheren Autokauf benötigen",
          offerText:
            "Unser Autohaus bietet ein vollständiges Automobilerlebnis für Kunden, die Qualität, Vertrauen und professionelle Unterstützung erwarten.",
          cards: [
            {
              number: "01",
              title: "Fahrzeugsuche",
              text: "Wir helfen Ihnen, das passende Fahrzeug nach Ihren Wünschen zu finden.",
            },
            {
              number: "02",
              title: "Fahrzeugprüfung",
              text: "Jedes Fahrzeug wird sorgfältig auf Zustand, Historie und Qualität geprüft.",
              dark: true,
            },
            {
              number: "03",
              title: "Finanzierungsunterstützung",
              text: "Flexible Finanzierungsmöglichkeiten, angepasst an Ihr Budget und Ihr Wunschfahrzeug.",
            },
            {
              number: "04",
              title: "Inzahlungnahme",
              text: "Erhalten Sie eine faire und professionelle Bewertung Ihres aktuellen Fahrzeugs.",
            },
            {
              number: "05",
              title: "Fahrzeuglieferung",
              text: "Ihr Fahrzeug kann sicher und professionell geliefert werden.",
              dark: true,
            },
            {
              number: "06",
              title: "Support nach dem Kauf",
              text: "Wir bleiben nach dem Kauf verfügbar, um Sie bei Dokumenten, Wartung und zukünftigen Anliegen zu unterstützen.",
            },
          ],
          processEyebrow: "Prozess",
          processTitle: "So funktioniert es",
          processText:
            "Unser optimierter Prozess sorgt für ein reibungsloses Erlebnis von Anfang bis Ende.",
          steps: [
            {
              number: "01",
              title: "Beratung",
              text: "Wir besprechen Ihre Wünsche und Bedürfnisse",
            },
            {
              number: "02",
              title: "Auswahl",
              text: "Wir helfen Ihnen, das passende Fahrzeug zu finden",
            },
            {
              number: "03",
              title: "Inspektion",
              text: "Gründliche Prüfung und Verifizierung",
            },
            {
              number: "04",
              title: "Übergabe",
              text: "Reibungslose Übergabe an Sie",
            },
          ],
          featureImageAlt: "Autoinnenraum",
          privateEyebrow: "Kundenerlebnis",
          privateTitle:
            "Entwickelt für Kunden, die Zeit, Details und Vertrauen schätzen",
          privateText:
            "Wir nehmen Ihnen den Stress beim Kauf eines Gebrauchtwagens ab. Unser Team unterstützt Sie bei Suche, Prüfung, Papierarbeit und Übergabe und hält Sie bei jedem Schritt informiert.",
          startJourney: "Reise starten",
          ctaEyebrow: "Autohaus-Service",
          ctaTitle: "Bereit, das richtige Auto zu finden?",
          ctaText:
            "Buchen Sie eine Beratung und lassen Sie sich von unserem Team durch ein einfaches und transparentes Autohaus-Erlebnis begleiten.",
          scheduleAppointment: "Termin vereinbaren",
        },

        cars: {
          pageTitle: "Unser Fahrzeugbestand",
          pageSubtitle: "Entdecken Sie unsere gesamte Auswahl an Gebrauchtfahrzeugen",
          vehicleCategory: "Fahrzeugkategorie",
          car: "Auto",
          brand: "Marke",
          status: "Status",
          price: "Preis",
          any: "Alle",
          available: "Verfügbar",
          reserved: "Reserviert",
          sold: "Verkauft",
          from: "von",
          until: "bis",
          loading: "Autos werden geladen...",
          noCars: "Keine Autos gefunden.",
          viewDetails: "Details ansehen",
        },

        contact: {
          heroEyebrow: "Kontaktieren Sie uns",
          heroTitle: "Lassen Sie uns das richtige Auto für Sie finden",
          heroText:
            "Kontaktieren Sie unser Team für Fahrzeuganfragen, Termine, Finanzierungsunterstützung oder Autohaus-Services.",
          getInTouch: "Kontakt aufnehmen",
          infoTitle:
            "Besuchen Sie unseren Showroom oder senden Sie uns eine Nachricht",
          infoText:
            "Unser Team ist bereit, Ihnen beim Finden, Prüfen, Finanzieren und Kaufen Ihres nächsten Fahrzeugs zu helfen.",
          location: "Standort",
          locationValue: "Lennestadt, Deutschland",
          email: "E-Mail",
          phone: "Telefon",
          workingHours: "Öffnungszeiten",
          workingHoursValue: "Montag - Samstag: 09:00 - 18:00",
          fullName: "Vollständiger Name",
          emailAddress: "E-Mail-Adresse",
          phoneNumber: "Telefonnummer",
          subject: "Betreff",
          message: "Ihre Nachricht",
          sending: "Wird gesendet...",
          sendMessage: "Nachricht senden",
          success: "Nachricht erfolgreich gesendet.",
          error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
          findUs: "Finden Sie uns",
          ourLocation: "Unser Standort",
          mapTitle: "Standort des Autohauses",
        },

        singleCar: {
          loading: "Auto wird geladen...",
          notFound: "Auto nicht gefunden.",
          home: "Startseite",
          cars: "Autos",
          carName: "Autoname",
          brand: "Marke",
          mileage: "Kilometerstand",
          fuel: "Kraftstoff",
          fuelType: "Kraftstoffart",
          transmission: "Getriebe",
          power: "Leistung",
          performance: "Leistung",
          backToCars: "Zurück zu den Autos",
          noImage: "Kein Bild",
          thumbnail: "Vorschaubild",
          firstRegistration: "Erstzulassung",
          vehicleOwner: "Fahrzeughalter",
          technicalData: "Technische Daten",
          noTechnicalData: "Keine technischen Daten verfügbar.",
          equipment: "Ausstattung",
          noEquipment: "Keine Ausstattung aufgelistet.",
          vehicleDescription: "Fahrzeugbeschreibung",
          noDescription: "Keine Beschreibung verfügbar.",
          tel: "Tel",
          writeEmail: "E-Mail schreiben",
          emailSubject: "Anfrage zu",
          emailHello: "Hallo,",
          emailInterested: "Ich interessiere mich für das Fahrzeug",
          emailMoreInfo: "Bitte senden Sie mir weitere Informationen.",
          emailThanks: "Vielen Dank.",
        },

        admin: {
          panel: "Adminbereich",
          brand: "AutoPark",
          manageCars: "Autos verwalten",
          addCar: "Auto hinzufügen",
          backToSite: "← Zur Webseite",
          logout: "Abmelden",
          addCarTitle: "Neues Auto hinzufügen",
          addCarSubtitle: "Fügen Sie ein neues Fahrzeug zum Bestand hinzu",
          basicInfo: "Grundinformationen",
          carName: "Autoname",
          brandLabel: "Marke",
          year: "Jahr",
          price: "Preis (€)",
          status: "Status",
          description: "Beschreibung",
          carPhotos: "Autofotos",
          uploadImages: "Bilder hochladen",
          remove: "Entfernen",
          technicalData: "Technische Daten",
          addStatistic: "+ Statistik hinzufügen",
          statisticName: "Statistikname",
          selectStatistic: "Statistik auswählen",
          value: "Wert",
          equipment: "Ausstattung",
          addCarButton: "Auto hinzufügen",
          uploading: "Wird hochgeladen & gespeichert...",
          addNewImages: "Neue Bilder hinzufügen",
          images: "Bilder",
          manageCarsTitle: "Autos verwalten",
          manageCarsSubtitle:
            "Autos anzeigen, bearbeiten, löschen und Status ändern.",
          loadingCars: "Autos werden geladen...",
          noCarsFound: "Keine Autos gefunden.",
          noImage: "Kein Bild",
          edit: "Bearbeiten",
          delete: "Löschen",
          editFullCar: "Auto vollständig bearbeiten",
          saveChanges: "Alle Änderungen speichern",
          saving: "Wird gespeichert...",
          available: "Verfügbar",
          sold: "Verkauft",
          reserved: "Reserviert",
          placeholderCarName: "z. B. Audi A4 S Line",
          placeholderBrand: "z. B. Audi",
          placeholderPrice: "25000",
          placeholderDescription: "Fahrzeugbeschreibung schreiben...",
          placeholderValue: "z. B. Gebrauchtfahrzeug",
          uploadOneImageAlert:
            "Bitte laden Sie mindestens ein Fahrzeugbild hoch.",
          requiredFieldsAlert: "Bitte füllen Sie alle Pflichtfelder aus.",
          successAddAlert: "Auto erfolgreich hinzugefügt!",
          deleteConfirm: "Möchten Sie dieses Auto wirklich löschen?",
          carNeedsImage: "Das Auto muss mindestens ein Bild haben.",
          failedAdd: "Auto konnte nicht hinzugefügt werden.",
          failedLoad: "Autos konnten nicht geladen werden.",
          failedStatus: "Status konnte nicht aktualisiert werden.",
          failedDelete: "Auto konnte nicht gelöscht werden.",
          failedUpdate: "Auto konnte nicht aktualisiert werden.",

          spec: {
            vehicleCondition: "Fahrzeugzustand",
            category: "Kategorie",
            series: "Baureihe",
            equipmentLine: "Ausstattungslinie",
            origin: "Herkunft",
            mileage: "Kilometerstand",
            engineDisplacement: "Hubraum",
            performance: "Leistung",
            driveType: "Antriebsart",
            fuelType: "Kraftstoffart",
            energyConsumption: "Energieverbrauch kombiniert",
            co2Emissions: "CO₂-Emissionen kombiniert",
            fuelConsumption: "Kraftstoffverbrauch",
            seats: "Anzahl der Sitze",
            doors: "Anzahl der Türen",
            transmission: "Getriebe",
            exteriorColor: "Außenfarbe",
            interiorColor: "Innenfarbe",
            bodyType: "Karosserieform",
            firstRegistration: "Erstzulassung",
            warranty: "Garantie",
            vehicleOwner: "Fahrzeughalter",
            hu: "HU",
            airConditioning: "Klimaanlage",
            parkingAssistance: "Einparkhilfe",
            airbags: "Airbags",
            cylinder: "Zylinder",
          },

          equipmentItems: {
            tintedWindows: "Getönte Scheiben",
            abs: "ABS",
            alarmSystem: "Alarmanlage",
            detachableTowbar: "Abnehmbare Anhängerkupplung",
            armrest: "Armlehne",
            onBoardComputer: "Bordcomputer",
            cdPlayer: "CD-Spieler",
            electricWindows: "Elektrische Fensterheber",
            electricMirrors: "Elektrische Seitenspiegel",
            immobiliser: "Elektrische Wegfahrsperre",
            esp: "ESP",
            frontWheelDrive: "Frontantrieb",
            luggagePartition: "Gepäckraumabtrennung",
            isofix: "Isofix",
            alloyWheels: "Leichtmetallfelgen",
            navigation: "Navigationssystem",
            fogLights: "Nebelscheinwerfer",
            breakdownKit: "Pannenset",
            particleFilter: "Partikelfilter",
            sunroof: "Schiebedach",
            powerSteering: "Servolenkung",
            heatedSeats: "Sitzheizung",
            soundSystem: "Soundsystem",
            cruiseControl: "Tempomat",
            tractionControl: "Traktionskontrolle",
            xenon: "Xenon-Scheinwerfer",
            centralLocking: "Zentralverriegelung",
          },
        },
      },
    },
  },

  lng: defaultLanguage,
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;